<results>
  <table if={props.results} class="table mt-4">
    <tr is="order-control" fields={fields()}></tr>

    <tr each={article in props.results.articles}>
      <td><watchlist-toggle id={article.id()} /></td>
      <td class="issue">{article.date()}</th>
      <td>{article.page()}</th>
      <td>
        <a
          href="#"
          onclick={event => toggle(article, event)}
        >{article.title()}</a>

        <template if={isOpen(article)}>
          <div class="mt-2">
            {article.journal()}<br />
            {article.issue()}<br />
            {article.structure()}
          </div>

          <div class="meta mt-3">
            <div>
              <div class="text-uppercase">Kommentar</span>
              <div>{article.comment()}</div>
            </div>

            <div if={article.categories().length} class="d-flex mt-2">
              <div class="mr-1">
                <img
                  src="{config.STATIC_URL}/images/tag.svg"
                  style="width: 26px"
                />
              </div>
              <div>
                <a
                  each={category in article.categories()}
                  is="filter-link"
                  name="category"
                  value={category}
                  class="d-block"
                >{category}</a>
              </div>
            </div>

            <div if={article.locations().length} class="d-flex mt-2">
              <div class="mr-1">
                <img
                  src="{config.STATIC_URL}/images/location.svg"
                  style="width: 16px; margin-left: 4px; margin-right: 6px;"
                />
              </div>
              <div>
                <a
                  each={location in article.locations()}
                  is="filter-link"
                  name="location"
                  value={location}
                  class="d-block"
                >{location}</a>
              </div>
            </div>

            <div if={article.people().length} class="d-flex mt-2">
              <div class="mr-1 mt-1">
                <img
                  src="{config.STATIC_URL}/images/person.svg"
                  style="width: 34px; height: initial; margin-left: -5px; margin-top: -10px; margin-right: -4px;"
                />
              </div>
              <div>
                <a
                  each={person in article.people()}
                  is="filter-link"
                  name="person"
                  value={person}
                  class="d-block"
                >{person}</a>
              </div>
            </div>
          </div>
        </template>
      </td>

      <td class="id">{article.id()}</td>
      <td class="image">
        <a href={article.imageUrl()} target="_blank">
          <img if={isOpen(article)} src={article.imageUrl()} />
          <img class="icon" if={!isOpen(article)} src="{config.STATIC_URL}/images/text.svg" />
        </a>

        <a
          if={isOpen(article)}
          href={article.slubUrl()}
          class="slub-link"
          target="_blank"
        >SLUB-Viewer</a>
      </td>
    </tr>
  </table>

  <script>
    import {Url, i18n} from '@wendig/lib'
    import config from '../lib/dotenv'

    export default class {
      constructor() {
        this.config = config
      }

      fields() {
        return {
          fields: [
            {},
            {name: 'issue', label: 'Ausgabe', direction: 'asc'},
            {name: 'page', label: 'Seite', direction: 'asc'},
            {name: 'title', label: 'Titel', direction: 'asc'},
            {name: 'id', label: 'ID', direction: 'asc'},
            {}
          ],
          default: 'title'
        }
      }

      isOpen(article) {
        return article.isOpen()
      }

      toggle(article, event) {
        if (event) event.preventDefault()

        if (this.isOpen(article)) {
          article.close()
          this.update()
        } else {
          article.load().then(() => {
            article.open()
            this.update()
          })
        }
      }
    }
  </script>
</results>
